/**
 * Styr vilket underflöde som gäller i arbetsplats-steg (4) per segment.
 * Varje post har exakt ett fält satt (matchar segment-titeln i offertflödet).
 */
export type SegmentRule =
  | { company: string }
  | { worplace: string }
  | { residential: string }
  | { other: string };

const Segments: SegmentRule[] = [
  { worplace: 'Kontorsåtervinning' },
  { company: 'Detaljhandel' },
  { company: 'Hotell & restaurang' },
  { residential: 'Bostadsfastighet' },
  { other: 'Annat' },
];

export default Segments;
